<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $tc('edit') }} {{ $t('vendormapping') }}</div>
      <router-link class="btn-blue" to="vendor-mapping">{{ $tc('vendor', 1) }} {{ $tc('list',2) }}</router-link>
    </div>

    <section class="white-wrapper">
      <form class="row">
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedCinema.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('cinema',2) }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(cinema, cinemaKey) in Cinemas"
                  :key="cinemaKey"
                  v-on:click="onSelectCinema(cinema)"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('searchmovie_tooltip')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0">Please Select Cinema.</span>
          </p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="SelectedVendor.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('vendor', 1) }}</label>
              <b-dropdown :text="SelectedVendor" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(vendor, vendorKey) in Vendors"
                  :key="vendorKey"
                  v-on:click="onSelectVendor(vendor)"
                >{{ vendor.v_name }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('searchmovie_tooltip')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && SelectedVendor.length == 0">Please Select Vendor.</span>
          </p>
        </div>

        <div v-for="(list,listKey) in selectedRawMaterials" :key="listKey" class="col-md-12 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="list.name && list.name.length > 0 ? 'shift-up' : '' "
              >{{ $tc('rawmaterials', 1) }}</label>
              <b-dropdown :text="list.name" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(raw, rawKey) in RawMaterials"
                  :key="rawKey"
                  v-on:click="onSelectRawMaterial(raw,listKey)"
                >{{ raw.rm_name }}</b-dropdown-item>
              </b-dropdown>
              <p
                v-if="submitted && list.name.length == 0"
                class="error_message"
              >Please Select Raw Material.</p>
            </div>

            <div class="input-material mr-2">
              <input
                v-model="list.vr_qty"
                type="text"
                name="mapquantity"
                id="mapquantity"
                v-validate="'required|numeric'"
              />
              <label>{{ $t('quantity') }}</label>
              <p class="error_message">
                <span
                  v-if="submitted && errors.has('mapquantity')"
                >{{ errors.first('mapquantity') }}</span>
              </p>
            </div>

            <div class="dropdown-curve-container mr-2">
              <!-- {{list}} -->
              <label :class="list.uom_unit && list.uom_unit.length > 0 ? 'shift-up' : '' ">UOM</label>
              <b-dropdown :text="list.uom_unit" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(uom, uomKey) in UomList"
                  :key="uomKey"
                  v-on:click="onSelectUnitOfM(uom,listKey)"
                >{{ uom.uom_unit }}</b-dropdown-item>
              </b-dropdown>
              <p class="error_message">
                <span
                  v-if="submitted && list.uom_unit.length == 0"
                >Please Select Unit of Measurement.</span>
              </p>
            </div>

            <div class="input-material mr-2">
              <input
                v-model="list.vr_rate"
                type="text"
                name="rate"
                id="rate"
                v-validate="'required|numeric'"
              />
              <label>{{ $t('rate') }}</label>
              <p class="error_message">
                <span v-if="submitted && errors.has('rate')">{{ errors.first('rate') }}</span>
              </p>
            </div>

            <div class="col-md-2 text-right pt-2">
              <button class="btn-transparent" v-if="listKey === 0" v-on:click="increaseRow()">
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button v-else @click="decreaseRow(listKey)" class="btn-transparent">
                <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <label>{{ $t('isdefaultvendor') }}</label>
            <label class="ios-switch ml-2">
              <input v-model="rmv_is_default_vendor" type="checkbox" class="ios-checkbox" checked />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <label>{{ $t('isactive') }}</label>
            <label class="ios-switch ml-2">
              <input v-model="rmv_is_active" type="checkbox" class="ios-checkbox" checked />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit()" class="btn-blue">{{ $t('update') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="vendor-mapping"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      isRoleID: true,
      submitted: false,
      rmv_is_active: true,
      rmv_is_default_vendor: true,
      vendor_id: "",
      cinema_id: "",
      rmv_id: "",
      SelectedVendor: "",
      selectedCinema: "",
      selectedRawMaterial: "",
      selectVendorOptions: ["India", "UAE", "USA", "UK", "China", "Sri Lanka"],
      Cinemas: [],
      Vendors: [],
      UomList: [],
      RawMaterials: [],
      measurements: [],
      selectedRawMaterials: [
        {
          name: "",
          rm_id: "",
          vr_qty: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: "",
          vr_is_active: true
        }
      ]
    };
  },
  async mounted() {
    await this.getunitsofmeasurements();
    await this.getRawMaterials();
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.vendor_id = this.$route.query.vendor_id;
    this.rmv_id = this.$route.query.rmv_id;
  },
  methods: {
    increaseRow: function() {
      this.selectedRawMaterials.push({
        name: "",
        rm_id: "",
        vr_qty: "",
        uom_id: "",
        uom_unit: "",
        vr_rate: "",
        vr_is_active: true
      });
    },
    decreaseRow: function(index) {
      this.selectedRawMaterials.splice(index, 1);
    },
    onSelectCinema: function(params) {
      this.selectedCinema = params.cine_name;
      this.cinema_id = params.cine_id;
    },
    onSelectRawMaterial: function(params, index) {
      this.selectedRawMaterials[index].name = params.rm_name;
      this.selectedRawMaterials[index].rm_id = params.rm_id;
    },
    onSelectUnitOfM: function(params, index) {
      this.selectedRawMaterials[index].uom_id = params.uom_id;
      this.selectedRawMaterials[index].uom_unit = params.uom_unit;
    },
    onSelectVendor: function(params) {
      this.SelectedVendor = params.v_name;
      this.vendor_id = params.v_id;
    },
    getMappingDetails: function() {
      let payload = {
        vendor_id: this.vendor_id
      };
      PosFnbService.GetVendorMappingDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.Cinemas = data.Records;
            let obj = data.Records[0];
            this.rmv_is_active = obj.rmv_is_active == "Y" ? true : false;
            this.rmv_is_default_vendor =
              obj.rmv_is_default_vendor == "Y" ? true : false;
            this.vendor_id = obj.vendor_id;
            this.cinema_id = obj.cinema_id;
            // console.log("cinema_id :", this.cinema_id);
            this.selectedRawMaterials = [];
            this.getCinemasList(this.cinema_id);
            this.getVendorsList(obj.vendor_id);
            data.Records.map((x, index) => {
              let array = this.RawMaterials.filter(
                y => y.rm_id === x.rawmaterial_id
              );
              if (array.length > 0) {
                let obj = {
                  name: array[0].rm_name,
                  rm_id: array[0].rm_id,
                  rmv_id: x.rmv_id,
                  vr_id: x.vr_id,
                  vr_qty: x.vr_qty,
                  vr_rate: x.vr_rate,
                  vr_is_active: true,
                  uom_id: x.uom_id,
                  uom_unit: null
                };
                this.getunitsofmeasurementsSingle(x.uom_id, obj);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getunitsofmeasurements: function() {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getunitsofmeasurementsSingle: function(uom_id, obj) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
        uom_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.selectedRawMaterials.push({
              ...obj,
              uom_unit: data.Records[0].uom_unit
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemasList: function(cinema_id) {
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
        cine_id: cinema_id
      };
      // console.log("payload :", payload);
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          // console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.selectedCinema = data.Records[0].cine_name;
            // console.log("this.selectedCinema", this.selectedCinema);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorsList: function(vendor_id) {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y",
        v_id: vendor_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.SelectedVendor = data.Records[0].v_name;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterials: function() {
      let loader = this.$loading.show();

      let payload = {
        tableName: "ms_raw_materials",
        rm_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          await this.getMappingDetails();
          setTimeout(() => loader.hide(), 1100);
        }); //message
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          let payload = {
            cinema_id: this.cinema_id,
            vendor_id: this.vendor_id,
            rmv_id: this.rmv_id,
            rmv_is_default_vendor:
              this.rmv_is_default_vendor == true ? "Y" : "N",
            rmv_is_active: this.rmv_is_active == true ? "Y" : "N",
            selectedRawMaterials: this.selectedRawMaterials
          };
          console.log("payload :", payload);
          PosFnbService.UpdateVendorMapping(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "vendor-mapping"
                });
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/editVendorMapping.vue